module.exports = __webpack_public_path__ + "img/03.1db33753.jpg";